import { render, staticRenderFns } from "./CasePrices.vue?vue&type=template&id=375769d9&"
import script from "./CasePrices.vue?vue&type=script&lang=js&"
export * from "./CasePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports